import React from 'react';
import BreadcrumbSection from '../breadcrumb/BreadcrumbSection';
import ProductDetailSection from '../product/ProductDetailSection';
import RelatedProductSection from '../product/RelatedProductSection';

const ShopDetailsMain = ({ productDetail }) => {
  return (
    <>
      <BreadcrumbSection current={productDetail.name} title={"ACCPP.STORE"} />
      <ProductDetailSection productDetail={productDetail} />
      <RelatedProductSection />
    </>
  );
};

export default ShopDetailsMain;
